import { isAfter, isBefore } from 'date-fns'
import { DisplayPassage } from '../data/mappers'

/**
 * @example '⇊', '1min', '59min', '1u08', '2u30'
 */
export function displayReadablePassageTime(date: Date, serverTijd: Date) {
  const ONE_MINUTE = 60_000
  const difference = date.getTime() - serverTijd.getTime()
  if (difference < 30_000) {
    return '↓↓' // Now
  } else if (difference < 60_000) {
    // more then 30 seconds & less than 60 seconds
    return '1 min'
  } else if (difference < 3_600_000) {
    // less than one hour
    return `${Math.floor(Math.abs(difference) / ONE_MINUTE)} min`
  } else {
    // more than one hour
    const hours = Math.floor(difference / (ONE_MINUTE * 60))
    const differenceInMinutes = Math.round(difference / ONE_MINUTE)
    const restMinutes = String(differenceInMinutes % 60).padStart(2, '0')
    return `${hours} u ${restMinutes}`
  }
}

export function getPassageTime(passage: DisplayPassage) {
  return passage.isLastStop
    ? passage.realtimeArrivalEpoch || passage.plannedArrivalEpoch
    : passage.realtimeDepartureEpoch || passage.plannedDepartureEpoch
}

export function filterPassagesAfterDate(
  passages: DisplayPassage[],
  afterDate: Date,
) {
  return passages.filter((passage) => {
    const passageTime = getPassageTime(passage)
    return isAfter(passageTime, afterDate)
  })
}
export function filterPassageBeforeLimit(
  passages: DisplayPassage[],
  dateLimit: Date,
) {
  return passages.filter((passage) => {
    const passageTime = getPassageTime(passage)
    return isBefore(passageTime, dateLimit)
  })
}
